//@flow
// TODO rights type
import { get, set } from 'lodash';

/*

rights: {
  admin: {
    rights: {
      canMakeAdmin: true,
      canEdit: true
    },
    lang: {
      canEditAll: true,
      en: true,
      es: 'managed',
      fr: 'franchised'
    },
    pathway: {
      regions: {
        all: true
      },
      lang: {

      }
    }
  }
}
*/

// rights/admin section

const getCanEditAdmin = (rights: Object): boolean => {
  return get(rights, 'admin.rights.canEdit', false);
};

const setCanEditAdmin = (rights: Object, value: boolean): void => {
  set(rights, 'admin.rights.canEdit', value);
};

const getCanMakeAdmin = (rights: Object): boolean => {
  return get(rights, 'admin.rights.canMakeAdmin', false);
};

const setCanMakeAdmin = (rights: Object, value: boolean): void => {
  set(rights, 'admin.rights.canMakeAdmin', value);
};

const canAccessRightsAdmin = (rights: Object): boolean => {
  return getCanEditAdmin(rights) || getCanMakeAdmin(rights);
};

// language section

const getCanEditAllLangs = (rights: Object): boolean => {
  return get(rights, 'admin.lang.canEditAll', false);
};

const setCanEditAllLangs = (rights: Object, value: boolean): void => {
  set(rights, 'admin.lang.canEditAll', value);
};

const canAccessLangAdmin = (rights: Object): boolean => {
  return getCanEditAllLangs(rights);
};

// general

const canAccessAdmin = (rights: Object): boolean => {
  return canAccessRightsAdmin(rights) || canAccessLangAdmin(rights);
};

const ACCESS_FUNCTIONS_BY_ADMIN_ITEM = {
  'rights': canAccessRightsAdmin,
  'lang': canAccessLangAdmin
};

const canAccessAdminItem = (rights: Object, itemKey: string): boolean => {
  const accessFn = ACCESS_FUNCTIONS_BY_ADMIN_ITEM[itemKey];
  if (!accessFn) {
    return false;
  }

  return accessFn(rights);
};

export default {
  canAccessAdmin,
  canAccessAdminItem,
  canAccessRightsAdmin,
  getCanEditAdmin,
  setCanEditAdmin,
  getCanMakeAdmin,
  setCanMakeAdmin,
  canAccessLangAdmin,
  getCanEditAllLangs,
  setCanEditAllLangs
};



// WEBPACK FOOTER //
// ./src/util/rights-util.js